export default __webpack_public_path__ + "static/media/picLinhTran.b12e2a7d.png";